<template>
  <div class="log">
    <img class="log-logo" src="//qn.xwyyjt.com/ht_xw_log_bg.png" alt="">
    <div class="log-form">
      <input placeholder="请输入手机号" class="ipt-btn has-mb" v-model="phone" type="text">
      <input placeholder="请输入密码"  class="ipt-btn" v-model="password" type="password">
    </div>
    <div @click="submitLog" class="log-btn-submit">登录</div>
    <img class="log-bot" src="//qn.xwyyjt.com/ht_log_bo.png" alt="">
  </div>
</template>

<script>
  export default {
    name: 'logIn',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        phone:'',
        password:''
      }
    },
    methods: {
      submitLog() {
        if (!this.phone)  {
          this.$toast('请输入手机号');
          return
        }
        if (!this.password)  {
          this.$toast('请输入密码');
          return
        }
        this.$http.post('stafflogin', {
          phone: this.phone.trim(),
          password: this.password.trim(),
        }).then(
          (res) => {
            if (res.data.code === 200) {
              window.localStorage.setItem('token',res.data.data.token || '');
              window.localStorage.setItem('type',res.data.data.type || '');
              window.localStorage.setItem('bookmoney',res.data.data.bookmoney || '');
              this.$toast('登录成功');
              setTimeout(()=>{
                this.$router.push('/home/extension')
              },1500)

            } else {
              this.$toast(res.data.msg || '系统错误');
            }
          }, (e) => {
            this.$toast('网络错误');
          }
        )
      }
    }
  }
</script>

<style lang="scss">
  .log {
    min-height: 100%;
    background-image: linear-gradient(#1B218A, #0393D7);
  }
  .log-tips {
    padding-top: 2rem;
    color: #000;
    font-size: .64rem;
    text-align: center;
  }
  .log-logo {
    display: block;
    padding-top: 1.6rem;
    margin: 0 auto;
    width: 4rem;
    height: auto;
    margin-bottom: .6rem;
  }

  .log-btn-submit {
    margin: .4rem auto 0;
    width:5.40rem;
    height:.72rem;
    background:#ffffff;
    border-radius:36px;
    font-size:.36rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight:400;
    color:#333333;
  }


  .ipt-btn {
    display: block;
    width: 5.4rem;
    height: .72rem;
    background: rgba(255,255,255,.2);
    border-radius: .45rem;
    margin:  0 auto;
    padding: 0 .42rem;
    box-sizing: border-box;
  }
  .has-mb {
    margin-bottom: .4rem;
  }
  .log-bot {
    width: 100%;
    height: auto;
  }

  input::-webkit-input-placeholder {
    color: rgba(0,0,0,.2);
  }
  input::-moz-input-placeholder {
    color: rgba(0,0,0,.2);
  }
  input::-ms-input-placeholder {
    color: rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/logIn.vue